import React from 'react'

import './change.css'

const classNames = require('classnames');

export default class Change extends React.Component<PropsType, StateType> {
  render() {
    const styles = classNames({
      'change-btn': true,
      'brown': true,
    })
    return (
      <div ref={this.props.refBtn} className={styles} style={{borderColor: this.props.color}}>
        <svg style={{'pointerEvents': 'none'}}  className="change-svg" width="9px" height="13px" viewBox="0 0 9 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <title>Stroke 2</title>
            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g id="01-Interface" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="01_Destop_07_Portfolio_03_Focus-Copy" transform="translate(-62.000000, -444.000000)" stroke="#D5735B" strokeWidth="2.5">
                    <g id="next" transform="translate(42.000000, 425.000000)">
                        <polyline style={{'pointerEvents': 'none'}} id="Stroke-2" points="26.9058065 29.9022439 22 25.451122 26.9058065 21"></polyline>
                    </g>
                </g>
            </g>
        </svg>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Photographer/Button/change.jsx